module.exports = __webpack_public_path__ + "HANMUChome-3.76d88436.png";